






export default
  watch:
    $route: (to, from) ->
      window.scrollTo(0, 0)
      document.title = @$route.meta.title
